import './utils/pollyfills';
import { setup } from 'goober';
import { h, render } from 'preact';

import { Gtm } from './apis/gtm';
import { Klaviyo } from './apis/klaviyo';
import { IQuizProps, Quiz } from './components/Quiz';
import { IQuizItem } from './types/quiz';
import { preloadImage } from './utils/images';
import { navigate } from './utils/navigate';

setup(h);

interface Props extends IQuizProps {
  brand: string;
  onFinish: never;
  successUrl: string;
  onAnswerSubmit: never;
  quizContainerId: string;
}

export const renderQuiz = async ({
  ids,
  quiz,
  brand,
  initial,
  successUrl,
  quizContainerId,
}: Props) => {
  Gtm.trackQuizStart(brand);
  const quizRoot = document.getElementById(quizContainerId);

  const onFinish = async (answers: Record<string, string | string[]>) => {
    if (window.DEBUG) {
      console.log(answers);
    }
    const email = answers['email_input'] as string;
    Klaviyo.push(['identify', { $email: email }]);
    Klaviyo.trackQuizFinished(answers);
    Gtm.trackQuizFinish(brand, email);

    setTimeout(() => {
      navigate(successUrl);
    }, 1500);
  };

  const onAnswerSubmit = async (
    idx: number,
    q: IQuizItem,
    answer?: string | string[],
  ) => {
    if (window.DEBUG) {
      console.log({
        brand,
        quizStep: idx,
        key: q.key,
        type: q.type,
        answer,
      });
    }
    Gtm.trackQuizAnswer({
      brand,
      step: idx,
      key: q.key,
      answer: answer || 'true',
      questionType: q.type,
    });
  };

  if (quizRoot) {
    const images = quiz.map(q => q.image).filter(q => typeof q === 'string');
    images.forEach(preloadImage);
    render(
      <Quiz
        ids={ids}
        quiz={quiz}
        initial={initial}
        onFinish={onFinish}
        onAnswerSubmit={onAnswerSubmit}
      />,
      quizRoot,
    );
  }
};

window.renderQuiz = renderQuiz;
